import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
export default function DoDocStatus(param) {
    var statusID = param.statusID, statusName = param.statusName, className = param.className, isOverDue = param.isOverDue;
    var _useState = _sliced_to_array(useState({
        statusName: statusName,
        statusID: statusID,
        isOverDue: isOverDue
    }), 2), elemData = _useState[0], setElemData = _useState[1];
    useEffect(function() {
        if (isOverDue) {
            setElemData(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    statusName: "เกินกำหนดจัดส่ง",
                    statusID: "overdue"
                });
            });
        } else {
            setElemData({
                statusName: statusName,
                statusID: statusID,
                isOverDue: isOverDue
            });
        }
    }, [
        statusName,
        statusID,
        isOverDue
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "px-3 py-1 doc-container do-doc-status-".concat(elemData.statusID, " ").concat(className),
        children: elemData.statusName
    });
}
